import { ADD_ADMIN_LICENSEE, ADD_ADMIN_LICENSEES, UPDATE_ADMIN_LICENSEE, DELETE_ADMIN_LICENSEE } from './action';

// Initial State
const initialState = [];

const licenseeReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_ADMIN_LICENSEE: {
               const newLicenseeList = [...state];
               newLicenseeList.push(action.payload);
               return newLicenseeList;
          }

          case ADD_ADMIN_LICENSEES: {
               return action.payload;
          }

          case UPDATE_ADMIN_LICENSEE: {
               const licenseeList = [...state];
               const newLicenseeList = [];
               for (let i = 0; i < licenseeList.length; i++) {
                    const licensee = licenseeList[i];
                    if (licensee.id === action.payload.id) {
                         newLicenseeList.push(action.payload);
                         continue;
                    }
                    newLicenseeList.push(licensee);
               }

               return newLicenseeList;
          }

          case DELETE_ADMIN_LICENSEE: {
               const licenseeList = [...state];
               return licenseeList.filter((licensee) => licensee.id !== action.payload);
          }

          default:
               return state;
     }
};

// Fetch licensee by id
export const getLicenseeById = (state, lid) => state.admin.licensees.find((licensee) => licensee.id === lid);

export default licenseeReducer;
